<template>
    <div :class="'accordion__header' + botRounded">
        {{ text ? text : 'El texto del header no ha sido colocado' }}
    </div>
</template>
<script>
    export default {
        props: ["text", "botrounded"],
        name: "AccordionHeader",
        computed: {
            botRounded(){
                return this.botrounded ? ' bottom-rounded-off' : '';
            }
        }
    }
</script>
<style>
    .bottom-rounded-off {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
</style>